import moment, { Moment } from 'moment'
import { useState } from 'react'
import {
  DateRangePicker,
  DateRangePickerShape,
  FocusedInputShape,
} from 'react-dates'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import StyledRangePicker from './TBDateRangePicker.react.styles'

export type StartEndDatesStrings = { startDate: string; endDate: string }
type TBDateRangePickerProps = {
  setDateFilter?: (dates: StartEndDatesStrings) => any
  isCustomDate?: boolean
  filter?: StartEndDatesStrings
  handleClear?: () => void
  utc?: boolean
  readOnly?: boolean
}
// TODO: Determine whether UTC should be the default (or only) option
const TBDateRangePicker = ({
  setDateFilter,
  isCustomDate,
  filter,
  handleClear,
  utc = false,
  readOnly = false,
}: TBDateRangePickerProps) => {
  const [focus, setFocus] = useState<FocusedInputShape | null>(null)
  const [dateRange, setRange] = useState({
    startDate: isCustomDate ? startOfDay(filter?.startDate, utc) : null,
    endDate: isCustomDate ? startOfDay(filter?.endDate, utc) : null,
  })

  const { startDate, endDate } = dateRange

  const handleDatesChange: DateRangePickerShape['onDatesChange'] = ({
    startDate,
    endDate,
  }) => {
    /*
    Testing options for disabling the daterange picker if invalid date is entered

    if(startDate == null) {
      const el = document.getElementById('unique_start_id')
      //@ts-ignore
      el.style.backgroundColor = 'red'
    } else {
      const el = document.getElementById('unique_start_id')
      //@ts-ignore
      el.style.backgroundColor = 'white'
    }
    if(endDate == null) {
      const el = document.getElementById('unique_end_id')
      //@ts-ignore
      el.style.backgroundColor = 'red'
    } else {
      const el = document.getElementById('unique_end_id')
      //@ts-ignore
      el.style.backgroundColor = 'white'
    }
    */

    const newStartDate = momentStartOfDay(startDate, utc),
      newEndDate = momentStartOfDay(endDate, utc)
    setRange({
      startDate: newStartDate,
      endDate: newEndDate,
    })
    if (!!newStartDate && !!newEndDate && setDateFilter) {
      setDateFilter({
        startDate: newStartDate.toISOString(),
        endDate: newEndDate.toISOString(),
      })
    } else if (handleClear && startDate === null && endDate === null) {
      handleClear()
    }
  }

  return (
    <StyledRangePicker className="tb-date-range-picker">
      <DateRangePicker
        startDate={startDate}
        startDateId="unique_start_id"
        endDate={endDate}
        endDateId="unique_end_id"
        onDatesChange={handleDatesChange}
        readOnly={readOnly}
        focusedInput={focus}
        onFocusChange={setFocus}
        isOutsideRange={() => false}
        // Allows selecting the same start and end date
        minimumNights={0}
        showClearDates
        enableOutsideDays
        small
        hideKeyboardShortcutsPanel
      />
    </StyledRangePicker>
  )
}

const startOfDay = (date: string | undefined, utc: boolean) =>
  (utc ? moment(date).utc() : moment(date)).startOf('D')

const momentStartOfDay = (date: Moment | null, utc: boolean) =>
  (utc ? date?.utc() : date)?.startOf('D') ?? null

export default TBDateRangePicker
